/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchOrderReqVo
 */
export interface BatchOrderReqVo {
    /**
     * 数据
     * @type {Array<Array<string>>}
     * @memberof BatchOrderReqVo
     */
    data?: Array<Array<string>>;
    /**
     * 仓库ID
     * @type {number}
     * @memberof BatchOrderReqVo
     */
    warehouseId?: number;
    /**
     * 订单类型
     * @type {number}
     * @memberof BatchOrderReqVo
     */
    orderType?: number;
    /**
     * 运输方式ID
     * @type {number}
     * @memberof BatchOrderReqVo
     */
    transportMethodId?: number;
    /**
     * 用户ID
     * @type {number}
     * @memberof BatchOrderReqVo
     */
    userId?: number;
}

/**
 * Check if a given object implements the BatchOrderReqVo interface.
 */
export function instanceOfBatchOrderReqVo(value: object): value is BatchOrderReqVo {
    return true;
}

export function BatchOrderReqVoFromJSON(json: any): BatchOrderReqVo {
    return BatchOrderReqVoFromJSONTyped(json, false);
}

export function BatchOrderReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchOrderReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : json['data'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'orderType': json['orderType'] == null ? undefined : json['orderType'],
        'transportMethodId': json['transportMethodId'] == null ? undefined : json['transportMethodId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
    };
}

export function BatchOrderReqVoToJSON(json: any): BatchOrderReqVo {
    return BatchOrderReqVoToJSONTyped(json, false);
}

export function BatchOrderReqVoToJSONTyped(value?: BatchOrderReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'],
        'warehouseId': value['warehouseId'],
        'orderType': value['orderType'],
        'transportMethodId': value['transportMethodId'],
        'userId': value['userId'],
    };
}

